import React from "react";
import styled from "styled-components";
// Components
import ClientSlider from "../Elements/ClientSlider";
import ServiceBox from "../Elements/ServiceBox";
import FullButton from "../Buttons/FullButton";
// Assets

import HomeImage1 from "../../assets/jpg_png/home6.jpg";
import HomeImage3 from "../../assets/jpg_png/home8.jpg";
import HomeImage4 from "../../assets/jpg_png/home9.jpg";
import Logo from "../../assets/jpg_png/logo.png";
//Css
import "../../style/TopNavbar.css";
import { Link } from "react-scroll";

export default function Services() {
  return (
    <Wrapper id="services">
      <div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <ClientSlider />
        </div>
      </div>
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold" style={{ color: "#9E9D24" }}>
              Our Awesome Services
            </h1>
            <p className="font15" style={{ color: "#111", fontWeight: "600" }}>
              "Quality design must have a sence of authenticity",
              <br /> "If you stay true to your aesthetic and what you belive in,
              that Confidence will convince even the most intimidating client "
            </p>
          </HeaderInfo>
          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                icon="roller"
                title="Visit Site"
                subtitle="site visits before the design phase of a project is crucial in helping us understand the local culture of a place."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="monitor"
                title="3D Design"
                subtitle="3D interior design is a design which represents the realistic image of the project, basically its an action plan of the inner space of any shop, building, showroom, or anything else."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Review Designs"
                subtitle="A design review is a product development milestone in which you assess a product design against specific criteria. The design review phase may identify problems in the current design or prototype before implementation."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="printer"
                title="Provide Services"
                subtitle="Full service interior design involves an interior designer or design team managing your entire project, from initial concept to installation to magazine-worthy finishing touches.."
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>
        </div>
        <div className="lightBg">
          <div className="container">
            <Advertising className="flexSpaceCenter">
              <AddLeft>
                <h4 className="font15 semiBold" style={{ color: "#7620ff" }}>
                  --A few words about our company
                </h4>
                <h2 className="font40 extraBold" style={{ color: "#9E9D24" }}>
                  SPACE IS THE BREATH OF ART
                </h2>
                <p
                  className="font12"
                  style={{
                    color: "#111",
                    fontSize: "14px",
                    fontWeight: "600",
                    textAlign: "justify",
                  }}
                >
                  Nlite Interors is Interior and Construction company
                  established in 2019,Our ethos is excellence in design and
                  delivery; working across architecture master planning,
                  interior design, and graphic design, our mission is to
                  understand our client's cultural,functional,operational and
                  commercial needs.
                  <br />
                  We are team of designers,technicians and project managers. It
                  is our job to translate the idea into a production ready
                  design and then manage the project through to successful
                  handover.
                </p>
                <ButtonsRow
                  className="flexNullCenter"
                  style={{ margin: "30px 0" }}
                >
                  <div style={{ width: "190px" }}>
                    <Link to="contact" spy={true} smooth={true} offset={-80}>
                      {" "}
                      <FullButton
                        title="Contact Us"
                        // action={() => alert("clicked")}
                      />
                    </Link>
                  </div>
                  <div style={{ width: "190px", marginLeft: "15px" }}>
                    {/* <FullButton
                      title="Contact Us"
                      action={() => alert("clicked")}
                      border
                    /> */}
                  </div>
                </ButtonsRow>
              </AddLeft>
              <AddRight>
                <AddRightInner>
                  <div className="flexNullCenter">
                    <AddImgWrapp1 className="flexCenter">
                      <img src={HomeImage1} alt="office" />
                    </AddImgWrapp1>
                    <AddImgWrapp2>
                      <img src={HomeImage3} alt="office" />
                    </AddImgWrapp2>
                  </div>
                  <div className="flexNullCenter">
                    <AddImgWrapp3>
                      <img src={Logo} alt="office" />
                    </AddImgWrapp3>
                    <AddImgWrapp4>
                      <img src={HomeImage4} alt="office" />
                    </AddImgWrapp4>
                  </div>
                </AddRightInner>
              </AddRight>
            </Advertising>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 25%;
  /* margin-right: 5%;
  margin-top: 2rem;
  margin-bottom: 2rem; */
  margin: 2rem 3rem 2rem 0rem;
  padding: 20px 20px 10px 20px;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  border-radius: 8px;
  text-align: justify;
  @media (max-width: 860px) {
    width: 100%;
    padding: 20px 10px 20px 10px;
    margin-left: auto;
    margin-right: auto;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;
const AddRightInner = styled.div`
  width: 100%;
`;
const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: 406px;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
  @media (max-width: 991px) {
    width: 100%;
  }
`;
const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: 333px;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
  @media (max-width: 991px) {
    display: none;
  }
`;
const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: 125px;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
  @media (max-width: 991px) {
    width: 100%;
  }
`;
const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5%auto;
  img {
    width: 100%;
    height: 224px;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
  @media (max-width: 991px) {
    display: none;
  }
`;
